import { MedicalConditionSubmit } from '../../MedicalCondition/utils/types';
import { MedicalHistorySubmit } from './types';

export const useFollowingQuestions = [
  {
    id: 'tobacco_products',
    title: 'Tobacco Products',
    description: null,
    is_required: false,
    is_conditional: false,
    type: null,
    options: null,
  },
  {
    id: 'recreational_drugs',
    title: 'Recreational Drugs',
    description: null,
    is_required: false,
    is_conditional: false,
    type: null,
    options: null,
  },
  {
    id: 'prescription_medication_for_non_medical_reasons',
    title: 'Prescription medication for non-medical reasons',
    description: null,
    is_required: false,
    is_conditional: false,
    type: null,
    options: null,
  },
];

export const MedicalHistoryDefault: MedicalHistorySubmit = {
  under_care_of_physician: null,
  conditions_treated: null,
  taking_medication: null,
  medications: '',
  allergic_to_medications: null,
  medications_allergies: null,
  using_substances: [],
  interested_in_stopping: null,
  height_feet: '',
  height_inches: '',
  height: '',
  weight: '',
  prescription_medication_for_non_medical_reasons: false,
  tobacco_products: false,
  recreational_drugs: false,
};

export const MedicalConditionDefault: MedicalConditionSubmit = {
  arthritis: false,
  cancer: false,
  dementia_alzheimers: false,
  heart_disease: false,
  dry_mouth: false,
  obesity: false,
  stroke: false,
  diabetes: false,
  pregnancy_or_breastfeeding: false,
  respiratory_conditions: false,
  conditions_not_listed: '',
  medical_condition_none_of_the_above: false,
};

export const allergiesOptions = [
  { value: 'Ants', label: 'Ants', id: '1' },
  { value: 'Bees', label: 'Bees', id: '2' },
  { value: 'Cats', label: 'Cats', id: '3' },
  { value: "Cow's milk", label: "Cow's milk", id: '4' },
  { value: 'Dander Unspecified', label: 'Dander Unspecified', id: '5' },
  { value: 'Dogs', label: 'Dogs', id: '6' },
  { value: 'Feather', label: 'Feather', id: '7' },
  { value: 'Hornets', label: 'Hornets', id: '8' },
  { value: 'Horses', label: 'Horses', id: '9' },
  { value: 'Scorpion venom', label: 'Scorpion venom', id: '10' },
  { value: 'Spider venom', label: 'Spider venom', id: '11' },
  { value: 'Wasp venom', label: 'Wasp venom', id: '12' },
  { value: 'Allergy, Unspecified', label: 'Allergy, Unspecified', id: '13' },
  { value: 'Seasonal, Hay fever', label: 'Seasonal, Hay fever', id: '14' },
  { value: 'Dust', label: 'Dust', id: '15' },
  { value: 'Environmental, Unspecified', label: 'Environmental, Unspecified', id: '16' },
  { value: 'Grass pollen', label: 'Grass pollen', id: '17' },
  { value: 'Mold', label: 'Mold', id: '18' },
  { value: 'Pesticide', label: 'Pesticide', id: '19' },
  { value: 'Plants', label: 'Plants', id: '20' },
  { value: 'Pollen', label: 'Pollen', id: '21' },
  { value: 'Seeds', label: 'Seeds', id: '22' },
  { value: 'Sunlight (skin sensitivity to sun)', label: 'Sunlight (skin sensitivity to sun)', id: '23' },
  { value: 'Wood', label: 'Wood', id: '24' },
  { value: 'Wool', label: 'Wool', id: '25' },
  { value: 'Legumes', label: 'Legumes', id: '26' },
  { value: 'Oats', label: 'Oats', id: '27' },
  { value: 'Wheat', label: 'Wheat', id: '28' },
  { value: 'Carrot', label: 'Carrot', id: '29' },
  { value: 'Corn', label: 'Corn', id: '30' },
  { value: 'Fruit', label: 'Fruit', id: '31' },
  { value: 'Olive oil', label: 'Olive oil', id: '32' },
  { value: 'Strawberries', label: 'Strawberries', id: '33' },
  { value: 'Tomato', label: 'Tomato', id: '34' },
  { value: 'Almond', label: 'Almond', id: '35' },
  { value: 'Cashew', label: 'Cashew', id: '36' },
  { value: 'Coconut oil', label: 'Coconut oil', id: '37' },
  { value: 'Hazelnut', label: 'Hazelnut', id: '38' },
  { value: 'Nuts, unspecified', label: 'Nuts, unspecified', id: '39' },
  { value: 'Peanut', label: 'Peanut', id: '40' },
  { value: 'Walnut', label: 'Walnut', id: '41' },
  { value: 'Fish', label: 'Fish', id: '42' },
  { value: 'Shellfish', label: 'Shellfish', id: '43' },
  { value: 'Shrimp', label: 'Shrimp', id: '44' },
  { value: 'Cheese', label: 'Cheese', id: '45' },
  { value: 'Chocolate', label: 'Chocolate', id: '46' },
  { value: 'Cinnamon', label: 'Cinnamon', id: '47' },
  { value: 'Dairy product', label: 'Dairy product', id: '48' },
  { value: 'Eggs', label: 'Eggs', id: '49' },
  { value: 'Food, Unspecified', label: 'Food, Unspecified', id: '50' },
  { value: 'Gelatin', label: 'Gelatin', id: '51' },
  { value: 'Gluten sensitivity', label: 'Gluten sensitivity', id: '52' },
  { value: 'Mushroom', label: 'Mushroom', id: '53' },
  { value: 'Potato', label: 'Potato', id: '54' },
  { value: 'Soy protein sensitivity', label: 'Soy protein sensitivity', id: '55' },
  { value: 'Sulfite based food preservative', label: 'Sulfite based food preservative', id: '56' },
  { value: 'Pork', label: 'Pork', id: '57' },
  { value: 'Red meat', label: 'Red meat', id: '58' },
  { value: 'Alcohol products', label: 'Alcohol products', id: '59' },
  { value: 'Aspartame', label: 'Aspartame', id: '60' },
  { value: 'Boric acid', label: 'Boric acid', id: '61' },
  { value: 'Caffeine', label: 'Caffeine', id: '62' },
  { value: 'Castor oil', label: 'Castor oil', id: '63' },
  { value: 'Dye', label: 'Dye', id: '64' },
  { value: 'Glycine', label: 'Glycine', id: '65' },
  { value: 'Lithium', label: 'Lithium', id: '66' },
  { value: 'Lubricant, Unspecified', label: 'Lubricant, Unspecified', id: '67' },
  { value: 'Perfume', label: 'Perfume', id: '68' },
  { value: 'Tryptophan', label: 'Tryptophan', id: '69' },
  { value: 'Vitamin A', label: 'Vitamin A', id: '70' },
  { value: 'Vitamin D', label: 'Vitamin D', id: '71' },
  { value: 'Vitamin K', label: 'Vitamin K', id: '72' },
  { value: 'Coal tar', label: 'Coal tar', id: '73' },
  { value: 'Cosmetic', label: 'Cosmetic', id: '74' },
  { value: 'Gauze', label: 'Gauze', id: '75' },
  { value: 'Latex', label: 'Latex', id: '76' },
  { value: 'Paraffin', label: 'Paraffin', id: '77' },
  { value: 'Rubber', label: 'Rubber', id: '78' },
  { value: 'Silicone', label: 'Silicone', id: '79' },
  { value: 'Substance, Unspecified', label: 'Substance, Unspecified', id: '80' },
  { value: 'Sulfur', label: 'Sulfur', id: '81' },
  { value: 'Tape', label: 'Tape', id: '82' },
  { value: 'Aluminum', label: 'Aluminum', id: '83' },
  { value: 'Gold', label: 'Gold', id: '84' },
  { value: 'Metal, Unspecified', label: 'Metal, Unspecified', id: '85' },
  { value: 'Nickel', label: 'Nickel', id: '86' },
  { value: 'Zinc', label: 'Zinc', id: '87' },
];

export const medicationOptions = [
  { value: 'Atorvastatin', label: 'Atorvastatin', id: '1' },
  { value: 'Metformin', label: 'Metformin', id: '2' },
  { value: 'Lisinopril', label: 'Lisinopril', id: '3' },
  { value: 'Levothyroxine', label: 'Levothyroxine', id: '4' },
  { value: 'Amlodipine', label: 'Amlodipine', id: '5' },
  { value: 'Metoprolol', label: 'Metoprolol', id: '6' },
  { value: 'Albuterol', label: 'Albuterol', id: '7' },
  { value: 'Losartan', label: 'Losartan', id: '8' },
  { value: 'Omeprazole', label: 'Omeprazole', id: '9' },
  { value: 'Gabapentin', label: 'Gabapentin', id: '10' },
  { value: 'Sertraline', label: 'Sertraline', id: '11' },
  { value: 'Hydrochlorothiazide', label: 'Hydrochlorothiazide', id: '12' },
  { value: 'Rosuvastatin', label: 'Rosuvastatin', id: '13' },
  {
    value: 'Dextroamphetamine; Dextroamphetamine Saccharate; Amphetamine; Amphetamine Aspartate',
    label: 'Dextroamphetamine; Dextroamphetamine Saccharate; Amphetamine; Amphetamine Aspartate',
    id: '14',
  },
  { value: 'Escitalopram', label: 'Escitalopram', id: '15' },
  { value: 'Pantoprazole', label: 'Pantoprazole', id: '16' },
  { value: 'Montelukast', label: 'Montelukast', id: '17' },
  { value: 'Trazodone', label: 'Trazodone', id: '18' },
  { value: 'Simvastatin', label: 'Simvastatin', id: '19' },
  { value: 'Tamsulosin', label: 'Tamsulosin', id: '20' },
  { value: 'Bupropion', label: 'Bupropion', id: '21' },
  { value: 'Fluoxetine', label: 'Fluoxetine', id: '22' },
  { value: 'Acetaminophen; Hydrocodone', label: 'Acetaminophen; Hydrocodone', id: '23' },
  { value: 'Furosemide', label: 'Furosemide', id: '24' },
  { value: 'Fluticasone', label: 'Fluticasone', id: '25' },
  { value: 'Amoxicillin', label: 'Amoxicillin', id: '26' },
  { value: 'Apixaban', label: 'Apixaban', id: '27' },
  { value: 'Insulin Glargine', label: 'Insulin Glargine', id: '28' },
  { value: 'Meloxicam', label: 'Meloxicam', id: '29' },
  { value: 'Prednisone', label: 'Prednisone', id: '30' },
  { value: 'Duloxetine', label: 'Duloxetine', id: '31' },
  { value: 'Methylphenidate', label: 'Methylphenidate', id: '32' },
  { value: 'Ibuprofen', label: 'Ibuprofen', id: '33' },
  { value: 'Carvedilol', label: 'Carvedilol', id: '34' },
  { value: 'Potassium Chloride', label: 'Potassium Chloride', id: '35' },
  { value: 'Aspirin', label: 'Aspirin', id: '36' },
  { value: 'Pravastatin', label: 'Pravastatin', id: '37' },
  { value: 'Ergocalciferol', label: 'Ergocalciferol', id: '38' },
  { value: 'Allopurinol', label: 'Allopurinol', id: '39' },
  { value: 'Citalopram', label: 'Citalopram', id: '40' },
  { value: 'Alprazolam', label: 'Alprazolam', id: '41' },
  { value: 'Glipizide', label: 'Glipizide', id: '42' },
  { value: 'Cetirizine', label: 'Cetirizine', id: '43' },
  { value: 'Venlafaxine', label: 'Venlafaxine', id: '44' },
  { value: 'Cyclobenzaprine', label: 'Cyclobenzaprine', id: '45' },
  { value: 'Hydroxyzine', label: 'Hydroxyzine', id: '46' },
  { value: 'Clopidogrel', label: 'Clopidogrel', id: '47' },
  { value: 'Semaglutide', label: 'Semaglutide', id: '48' },
  { value: 'Famotidine', label: 'Famotidine', id: '49' },
  { value: 'Estradiol', label: 'Estradiol', id: '50' },
  { value: 'Diclofenac', label: 'Diclofenac', id: '51' },
  { value: 'Spironolactone', label: 'Spironolactone', id: '52' },
  { value: 'Hydrochlorothiazide; Lisinopril', label: 'Hydrochlorothiazide; Lisinopril', id: '53' },
  { value: 'Buspirone', label: 'Buspirone', id: '54' },
  { value: 'Tramadol', label: 'Tramadol', id: '55' },
  { value: 'Empagliflozin', label: 'Empagliflozin', id: '56' },
  { value: 'Clonazepam', label: 'Clonazepam', id: '57' },
  { value: 'Lamotrigine', label: 'Lamotrigine', id: '58' },
  { value: 'Fluticasone; Salmeterol', label: 'Fluticasone; Salmeterol', id: '59' },
  { value: 'Oxycodone', label: 'Oxycodone', id: '60' },
  { value: 'Ondansetron', label: 'Ondansetron', id: '61' },
  { value: 'Cholecalciferol', label: 'Cholecalciferol', id: '62' },
  { value: 'Atenolol', label: 'Atenolol', id: '63' },
  { value: 'Glimepiride', label: 'Glimepiride', id: '64' },
  { value: 'Folic Acid', label: 'Folic Acid', id: '65' },
  { value: 'Zolpidem', label: 'Zolpidem', id: '66' },
  { value: 'Latanoprost', label: 'Latanoprost', id: '67' },
  { value: 'Doxycycline', label: 'Doxycycline', id: '68' },
  { value: 'Lisdexamfetamine', label: 'Lisdexamfetamine', id: '69' },
  { value: 'Insulin Lispro', label: 'Insulin Lispro', id: '70' },
  { value: 'Clonidine', label: 'Clonidine', id: '71' },
  { value: 'Loratadine', label: 'Loratadine', id: '72' },
  { value: 'Finasteride', label: 'Finasteride', id: '73' },
  { value: 'Dulaglutide', label: 'Dulaglutide', id: '74' },
  { value: 'Hydrochlorothiazide; Losartan', label: 'Hydrochlorothiazide; Losartan', id: '75' },
  { value: 'Insulin Aspart', label: 'Insulin Aspart', id: '76' },
  { value: 'Propranolol', label: 'Propranolol', id: '77' },
  { value: 'Azithromycin', label: 'Azithromycin', id: '78' },
  { value: 'Ezetimibe', label: 'Ezetimibe', id: '79' },
  { value: 'Ethinyl Estradiol; Norethindrone', label: 'Ethinyl Estradiol; Norethindrone', id: '80' },
  { value: 'Lorazepam', label: 'Lorazepam', id: '81' },
  { value: 'Quetiapine', label: 'Quetiapine', id: '82' },
  { value: 'Budesonide; Formoterol', label: 'Budesonide; Formoterol', id: '83' },
  { value: 'Topiramate', label: 'Topiramate', id: '84' },
  { value: 'Warfarin', label: 'Warfarin', id: '85' },
  { value: 'Sitagliptin', label: 'Sitagliptin', id: '86' },
  { value: 'Amitriptyline', label: 'Amitriptyline', id: '87' },
  { value: 'Fenofibrate', label: 'Fenofibrate', id: '88' },
  { value: 'Naproxen', label: 'Naproxen', id: '89' },
  { value: 'Rivaroxaban', label: 'Rivaroxaban', id: '90' },
  { value: 'Pregabalin', label: 'Pregabalin', id: '91' },
  { value: 'Paroxetine', label: 'Paroxetine', id: '92' },
  { value: 'Celecoxib', label: 'Celecoxib', id: '93' },
  { value: 'Tizanidine', label: 'Tizanidine', id: '94' },
  { value: 'Sumatriptan', label: 'Sumatriptan', id: '95' },
  { value: 'Amoxicillin; Clavulanate', label: 'Amoxicillin; Clavulanate', id: '96' },
  { value: 'Olmesartan', label: 'Olmesartan', id: '97' },
  { value: 'Acetaminophen; Oxycodone', label: 'Acetaminophen; Oxycodone', id: '98' },
  { value: 'Ethinyl Estradiol; Norgestimate', label: 'Ethinyl Estradiol; Norgestimate', id: '99' },
  { value: 'Diltiazem', label: 'Diltiazem', id: '100' },
  { value: 'Cephalexin', label: 'Cephalexin', id: '101' },
  { value: 'Triamcinolone', label: 'Triamcinolone', id: '102' },
  { value: 'Alendronate', label: 'Alendronate', id: '103' },
  { value: 'Baclofen', label: 'Baclofen', id: '104' },
  { value: 'Mirtazapine', label: 'Mirtazapine', id: '105' },
  { value: 'Aripiprazole', label: 'Aripiprazole', id: '106' },
  { value: 'Ferrous Sulfate', label: 'Ferrous Sulfate', id: '107' },
  { value: 'Chlorthalidone', label: 'Chlorthalidone', id: '108' },
  { value: 'Dexmethylphenidate', label: 'Dexmethylphenidate', id: '109' },
  { value: 'Oxybutynin', label: 'Oxybutynin', id: '110' },
  { value: 'Lovastatin', label: 'Lovastatin', id: '111' },
  { value: 'Hydroxychloroquine', label: 'Hydroxychloroquine', id: '112' },
  { value: 'Valacyclovir', label: 'Valacyclovir', id: '113' },
  { value: 'Acetaminophen', label: 'Acetaminophen', id: '114' },
  { value: 'Dapagliflozin', label: 'Dapagliflozin', id: '115' },
  { value: 'Hydrochlorothiazide; Triamterene', label: 'Hydrochlorothiazide; Triamterene', id: '116' },
  { value: 'Valsartan', label: 'Valsartan', id: '117' },
  { value: 'Testosterone', label: 'Testosterone', id: '118' },
  { value: 'Isosorbide', label: 'Isosorbide', id: '119' },
  { value: 'Pioglitazone', label: 'Pioglitazone', id: '120' },
  { value: 'Hydralazine', label: 'Hydralazine', id: '121' },
  { value: 'Esomeprazole', label: 'Esomeprazole', id: '122' },
  { value: 'Levetiracetam', label: 'Levetiracetam', id: '123' },
  { value: 'Azelastine', label: 'Azelastine', id: '124' },
  { value: 'Progesterone', label: 'Progesterone', id: '125' },
  { value: 'Methocarbamol', label: 'Methocarbamol', id: '126' },
  { value: 'Insulin Detemir', label: 'Insulin Detemir', id: '127' },
  { value: 'Ethinyl Estradiol; Levonorgestrel', label: 'Ethinyl Estradiol; Levonorgestrel', id: '128' },
  { value: 'Meclizine', label: 'Meclizine', id: '129' },
  { value: 'Benzonatate', label: 'Benzonatate', id: '130' },
  { value: 'Cyanocobalamin', label: 'Cyanocobalamin', id: '131' },
  { value: 'Methotrexate', label: 'Methotrexate', id: '132' },
  { value: 'Metronidazole', label: 'Metronidazole', id: '133' },
  { value: 'Acyclovir', label: 'Acyclovir', id: '134' },
  { value: 'Norethindrone', label: 'Norethindrone', id: '135' },
  { value: 'Prednisolone', label: 'Prednisolone', id: '136' },
  { value: 'Thyroid', label: 'Thyroid', id: '137' },
  { value: 'Insulin Degludec', label: 'Insulin Degludec', id: '138' },
  { value: 'Liraglutide', label: 'Liraglutide', id: '139' },
  { value: 'Morphine', label: 'Morphine', id: '140' },
  { value: 'Enalapril', label: 'Enalapril', id: '141' },
  { value: 'Drospirenone; Ethinyl Estradiol', label: 'Drospirenone; Ethinyl Estradiol', id: '142' },
  { value: 'Sulfamethoxazole; Trimethoprim', label: 'Sulfamethoxazole; Trimethoprim', id: '143' },
  { value: 'Fluticasone; Umeclidinium; Vilanterol', label: 'Fluticasone; Umeclidinium; Vilanterol', id: '144' },
  { value: 'Fluticasone; Vilanterol', label: 'Fluticasone; Vilanterol', id: '145' },
  { value: 'Donepezil', label: 'Donepezil', id: '146' },
  { value: 'Clindamycin', label: 'Clindamycin', id: '147' },
  { value: 'Docusate', label: 'Docusate', id: '148' },
  { value: 'Phentermine', label: 'Phentermine', id: '149' },
  { value: 'Memantine', label: 'Memantine', id: '150' },
  { value: 'Nifedipine', label: 'Nifedipine', id: '151' },
  { value: 'Levocetirizine', label: 'Levocetirizine', id: '152' },
  { value: 'Methylprednisolone', label: 'Methylprednisolone', id: '153' },
  { value: 'Tiotropium', label: 'Tiotropium', id: '154' },
  { value: 'Timolol', label: 'Timolol', id: '155' },
  { value: 'Clobetasol', label: 'Clobetasol', id: '156' },
  { value: 'Sildenafil', label: 'Sildenafil', id: '157' },
  { value: 'Nitrofurantoin', label: 'Nitrofurantoin', id: '158' },
  { value: 'Benazepril', label: 'Benazepril', id: '159' },
  { value: 'Fluconazole', label: 'Fluconazole', id: '160' },
  { value: 'Desogestrel; Ethinyl Estradiol', label: 'Desogestrel; Ethinyl Estradiol', id: '161' },
  { value: 'Mupirocin', label: 'Mupirocin', id: '162' },
  { value: 'Ropinirole', label: 'Ropinirole', id: '163' },
  { value: 'Nirmatrelvir; Ritonavir', label: 'Nirmatrelvir; Ritonavir', id: '164' },
  { value: 'Sacubitril; Valsartan', label: 'Sacubitril; Valsartan', id: '165' },
  { value: 'Acetaminophen; Codeine', label: 'Acetaminophen; Codeine', id: '166' },
  { value: 'Oxcarbazepine', label: 'Oxcarbazepine', id: '167' },
  { value: 'Cefdinir', label: 'Cefdinir', id: '168' },
  { value: 'Diazepam', label: 'Diazepam', id: '169' },
  { value: 'Amlodipine; Benazepril', label: 'Amlodipine; Benazepril', id: '170' },
  { value: 'Olanzapine', label: 'Olanzapine', id: '171' },
  { value: 'Tadalafil', label: 'Tadalafil', id: '172' },
  { value: 'Nebivolol', label: 'Nebivolol', id: '173' },
  { value: 'Valproate', label: 'Valproate', id: '174' },
  { value: 'Ketoconazole', label: 'Ketoconazole', id: '175' },
  { value: 'Dicyclomine', label: 'Dicyclomine', id: '176' },
  { value: 'Budesonide', label: 'Budesonide', id: '177' },
  { value: 'Albuterol; Ipratropium', label: 'Albuterol; Ipratropium', id: '178' },
  { value: 'Anastrozole', label: 'Anastrozole', id: '179' },
  { value: 'Doxazosin', label: 'Doxazosin', id: '180' },
  { value: 'Ciprofloxacin', label: 'Ciprofloxacin', id: '181' },
  { value: 'Metformin; Sitagliptin', label: 'Metformin; Sitagliptin', id: '182' },
  { value: 'Risperidone', label: 'Risperidone', id: '183' },
  { value: 'Torsemide', label: 'Torsemide', id: '184' },
  { value: 'Cyclosporine', label: 'Cyclosporine', id: '185' },
  { value: 'Dexlansoprazole', label: 'Dexlansoprazole', id: '186' },
  { value: 'Ramipril', label: 'Ramipril', id: '187' },
  { value: 'Verapamil', label: 'Verapamil', id: '188' },
  { value: 'Linaclotide', label: 'Linaclotide', id: '189' },
  { value: 'Rizatriptan', label: 'Rizatriptan', id: '190' },
  { value: 'Nortriptyline', label: 'Nortriptyline', id: '191' },
  { value: 'Insulin Human; Insulin Isophane Human', label: 'Insulin Human; Insulin Isophane Human', id: '192' },
  { value: 'Pramipexole', label: 'Pramipexole', id: '193' },
  { value: 'Ethinyl Estradiol; Etonogestrel', label: 'Ethinyl Estradiol; Etonogestrel', id: '194' },
  { value: 'Bimatoprost', label: 'Bimatoprost', id: '195' },
  { value: 'Nitroglycerin', label: 'Nitroglycerin', id: '196' },
  { value: 'Colchicine', label: 'Colchicine', id: '197' },
  { value: 'Promethazine', label: 'Promethazine', id: '198' },
  { value: 'Brimonidine', label: 'Brimonidine', id: '199' },
  { value: 'Irbesartan', label: 'Irbesartan', id: '200' },
  { value: 'Dorzolamide', label: 'Dorzolamide', id: '201' },
  { value: 'Hydrocortisone', label: 'Hydrocortisone', id: '202' },
  { value: 'Ticagrelor', label: 'Ticagrelor', id: '203' },
  { value: 'Liothyronine', label: 'Liothyronine', id: '204' },
  { value: 'Oseltamivir', label: 'Oseltamivir', id: '205' },
  { value: 'Ofloxacin', label: 'Ofloxacin', id: '206' },
  { value: 'Magnesium Salts', label: 'Magnesium Salts', id: '207' },
  { value: 'Desvenlafaxine', label: 'Desvenlafaxine', id: '208' },
  { value: 'Polyethylene Glycol 3350', label: 'Polyethylene Glycol 3350', id: '209' },
  { value: 'Solifenacin', label: 'Solifenacin', id: '210' },
  { value: 'Umeclidinium; Vilanterol', label: 'Umeclidinium; Vilanterol', id: '211' },
  { value: 'Lithium', label: 'Lithium', id: '212' },
  { value: 'Atomoxetine', label: 'Atomoxetine', id: '213' },
  { value: 'Sucralfate', label: 'Sucralfate', id: '214' },
  { value: 'Labetalol', label: 'Labetalol', id: '215' },
  { value: 'Sodium Salts', label: 'Sodium Salts', id: '216' },
  { value: 'Melatonin', label: 'Melatonin', id: '217' },
  { value: 'Doxepin', label: 'Doxepin', id: '218' },
  { value: 'Ipratropium', label: 'Ipratropium', id: '219' },
  { value: 'Omega-3-acid Ethyl Esters', label: 'Omega-3-acid Ethyl Esters', id: '220' },
  { value: 'Sodium Fluoride', label: 'Sodium Fluoride', id: '221' },
  { value: 'Mirabegron', label: 'Mirabegron', id: '222' },
  { value: 'Ketorolac', label: 'Ketorolac', id: '223' },
  { value: 'Lansoprazole', label: 'Lansoprazole', id: '224' },
  { value: 'Dorzolamide; Timolol', label: 'Dorzolamide; Timolol', id: '225' },
  { value: 'Ascorbic Acid', label: 'Ascorbic Acid', id: '226' },
  { value: 'Mycophenolate Mofetil', label: 'Mycophenolate Mofetil', id: '227' },
  { value: 'Telmisartan', label: 'Telmisartan', id: '228' },
  { value: 'Icosapent Ethyl', label: 'Icosapent Ethyl', id: '229' },
  { value: 'Chlorhexidine', label: 'Chlorhexidine', id: '230' },
  { value: 'Gemfibrozil', label: 'Gemfibrozil', id: '231' },
  { value: 'Ranolazine', label: 'Ranolazine', id: '232' },
  { value: 'Hydromorphone', label: 'Hydromorphone', id: '233' },
  { value: 'Dexamethasone', label: 'Dexamethasone', id: '234' },
  { value: 'Hydrochlorothiazide; Olmesartan', label: 'Hydrochlorothiazide; Olmesartan', id: '235' },
  { value: 'Nystatin', label: 'Nystatin', id: '236' },
  { value: 'Amiodarone', label: 'Amiodarone', id: '237' },
  { value: 'Tretinoin', label: 'Tretinoin', id: '238' },
  { value: 'Nabumetone', label: 'Nabumetone', id: '239' },
  { value: 'Epinephrine', label: 'Epinephrine', id: '240' },
  { value: 'Adalimumab', label: 'Adalimumab', id: '241' },
  { value: 'Betamethasone; Clotrimazole', label: 'Betamethasone; Clotrimazole', id: '242' },
  { value: 'Ketotifen', label: 'Ketotifen', id: '243' },
  { value: 'Vitamin E', label: 'Vitamin E', id: '244' },
  { value: 'Metoclopramide', label: 'Metoclopramide', id: '245' },
  { value: 'Calcium Phosphate; Cholecalciferol', label: 'Calcium Phosphate; Cholecalciferol', id: '246' },
  { value: 'Ciclopirox', label: 'Ciclopirox', id: '247' },
  { value: 'Acetaminophen; Butalbital; Caffeine', label: 'Acetaminophen; Butalbital; Caffeine', id: '248' },
  { value: 'Bisoprolol', label: 'Bisoprolol', id: '249' },
  { value: 'Olopatadine', label: 'Olopatadine', id: '250' },
  { value: 'Levofloxacin', label: 'Levofloxacin', id: '251' },
  { value: 'Polymyxin B; Trimethoprim', label: 'Polymyxin B; Trimethoprim', id: '252' },
  {
    value: 'Pancrelipase Amylase; Pancrelipase Lipase; Pancrelipase Protease',
    label: 'Pancrelipase Amylase; Pancrelipase Lipase; Pancrelipase Protease',
    id: '253',
  },
  { value: 'Calcitriol', label: 'Calcitriol', id: '254' },
  { value: 'Terbinafine', label: 'Terbinafine', id: '255' },
  { value: 'Indomethacin', label: 'Indomethacin', id: '256' },
  { value: 'Fexofenadine', label: 'Fexofenadine', id: '257' },
  { value: 'Diphenhydramine', label: 'Diphenhydramine', id: '258' },
  { value: 'Penicillin V', label: 'Penicillin V', id: '259' },
  { value: 'Dextromethorphan; Promethazine', label: 'Dextromethorphan; Promethazine', id: '260' },
  { value: 'Senna; Docusate', label: 'Senna; Docusate', id: '261' },
  { value: 'Lidocaine', label: 'Lidocaine', id: '262' },
  { value: 'Betamethasone', label: 'Betamethasone', id: '263' },
  { value: 'Ethinyl Estradiol; Norgestrel', label: 'Ethinyl Estradiol; Norgestrel', id: '264' },
  {
    value: 'Brompheniramine; Dextromethorphan; Pseudoephedrine',
    label: 'Brompheniramine; Dextromethorphan; Pseudoephedrine',
    id: '265',
  },
  { value: 'Fluocinonide', label: 'Fluocinonide', id: '266' },
  { value: 'Lactulose', label: 'Lactulose', id: '267' },
  { value: 'Hydroquinone', label: 'Hydroquinone', id: '268' },
  { value: 'Minocycline', label: 'Minocycline', id: '269' },
  { value: 'Fluorouracil', label: 'Fluorouracil', id: '270' },
  { value: 'Erythromycin', label: 'Erythromycin', id: '271' },
  { value: 'Codeine; Guaifenesin', label: 'Codeine; Guaifenesin', id: '272' },
  { value: 'Moxifloxacin', label: 'Moxifloxacin', id: '273' },
  { value: 'Dexamethasone; Neomycin; Polymyxin B', label: 'Dexamethasone; Neomycin; Polymyxin B', id: '274' },
  { value: 'Guanfacine', label: 'Guanfacine', id: '275' },
  { value: 'Medroxyprogesterone', label: 'Medroxyprogesterone', id: '276' },
  { value: 'Calcium', label: 'Calcium', id: '277' },
  { value: 'Carbidopa; Levodopa', label: 'Carbidopa; Levodopa', id: '278' },
  { value: 'Silver Sulfadiazine', label: 'Silver Sulfadiazine', id: '279' },
  { value: 'Sennosides', label: 'Sennosides', id: '280' },
  { value: 'Tobramycin', label: 'Tobramycin', id: '281' },
  {
    value: 'Polyethylene Glycol 3350 With Electrolytes',
    label: 'Polyethylene Glycol 3350 With Electrolytes',
    id: '282',
  },
  { value: 'Cefuroxime', label: 'Cefuroxime', id: '283' },
  { value: 'Atropine; Diphenoxylate', label: 'Atropine; Diphenoxylate', id: '284' },
  {
    value: 'Drospirenone; Ethinyl Estradiol; Levomefolate',
    label: 'Drospirenone; Ethinyl Estradiol; Levomefolate',
    id: '285',
  },
  { value: 'Ciprofloxacin; Dexamethasone', label: 'Ciprofloxacin; Dexamethasone', id: '286' },
  { value: 'Lactate', label: 'Lactate', id: '287' },
  { value: 'Thiamine', label: 'Thiamine', id: '288' },
  { value: 'Loratadine; Pseudoephedrine', label: 'Loratadine; Pseudoephedrine', id: '289' },
  { value: 'Dextromethorphan; Guaifenesin', label: 'Dextromethorphan; Guaifenesin', id: '290' },
  { value: 'Chlorpheniramine', label: 'Chlorpheniramine', id: '291' },
  { value: 'Adapalene; Benzoyl Peroxide', label: 'Adapalene; Benzoyl Peroxide', id: '292' },
  { value: 'Cyproheptadine', label: 'Cyproheptadine', id: '293' },
  { value: 'Ethinyl Estradiol; Ethynodiol', label: 'Ethinyl Estradiol; Ethynodiol', id: '294' },
  { value: 'Guaifenesin', label: 'Guaifenesin', id: '295' },
  { value: 'Neomycin; Polymyxin B; Hydrocortisone', label: 'Neomycin; Polymyxin B; Hydrocortisone', id: '296' },
  { value: 'Loperamide', label: 'Loperamide', id: '297' },
  { value: 'Azelate', label: 'Azelate', id: '298' },
  { value: 'Azelastine; Fluticasone', label: 'Azelastine; Fluticasone', id: '299' },
  { value: 'Sulfacetamide; Sulfur', label: 'Sulfacetamide; Sulfur', id: '300' },
];

export const allergyAndMedicationOptions = Array.from(
  new Map([...allergiesOptions, ...medicationOptions].map((option) => [option.label, option])).values(),
);
